import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Mock data for testimonials
const mockTestimonials = [
  {
    id: '1',
    name: 'Sarah Johnson',
    position: 'SEO Manager',
    company: 'GrowthTech',
    quote: 'SEO Link Market has transformed our outreach process. We now get high-quality backlinks easily with full transparency on metrics.',
    rating: 5,
    imageUrl: '/placeholder.svg'
  },
  {
    id: '2',
    name: 'Michael Chen',
    position: 'Digital Marketing Director',
    company: 'NexGen Media',
    quote: 'As a seller, I\'ve seen my monthly revenue double through this platform. The buyer request board makes finding new clients effortless.',
    rating: 5,
    imageUrl: '/placeholder.svg'
  },
  {
    id: '3',
    name: 'Emma Torres',
    position: 'Content Strategist',
    company: 'Altitude Agency',
    quote: 'The contextual messaging system makes communication easy, and the transparent metrics help us make informed decisions quickly.',
    rating: 4,
    imageUrl: '/placeholder.svg'
  }
];

const Testimonials = () => {
  const [testimonials] = useState(mockTestimonials);
  
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">What Our Users Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real experiences from buyers and sellers in our marketplace
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map(testimonial => (
            <Card key={testimonial.id} className="border-0 shadow-md">
              <CardContent className="pt-6 pb-6">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star 
                      key={i}
                      className={`h-5 w-5 ${i < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-200'}`}
                    />
                  ))}
                </div>
                
                <p className="text-gray-700 italic mb-6">"{testimonial.quote}"</p>
                
                <div className="flex items-center">
                  <div className="h-12 w-12 rounded-full overflow-hidden mr-4">
                    <img 
                      src={testimonial.imageUrl} 
                      alt={testimonial.name} 
                      className="h-full w-full object-cover"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = '/placeholder.svg';
                      }}
                    />
                  </div>
                  <div>
                    <div className="font-semibold">{testimonial.name}</div>
                    <div className="text-sm text-gray-500">
                      {testimonial.position}, {testimonial.company}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="mt-10 text-center">
          <Link to="/reviews">
            <Button variant="outline" size="lg">
              View All Reviews
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
